module.exports = __webpack_public_path__ + "static/media/2A.2ff1c267.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/2A.pdf
// module id = 81
// module chunks = 0